/**
 * 	(c) 2018 TERAOKA SEIKO CO., LTD. / 株式会社 寺岡精工
 * 	CONFIDENTIAL / 社外秘
 * 	無断開示・無断複製禁止
 */
/*
 * スクロール位置管理
 */
<script>
export default {
	props:{
	},
	data:function(){
		return {
			m_bRestoreScroll:true,
			m_key:'labelplus_scroll_offset',
			m_offset:{ 'x': 0, 'y': 0, },
		}
	},
	mounted:function(){
		// ブラウザスクロールのイベントリスナーを登録
		window.addEventListener('scroll', this.onScroll);
	},
	beforeDestroy:function(){
		// ブラウザスクロールのイベントリスナーを削除
		window.removeEventListener('scroll', this.onScroll);
	},
	computed:{
	},
	methods:{
		onScroll: function(){
			this.m_offset = {
				'x': window.scrollX,
				'y': window.scrollY,
			}
			// console.log('do scloll: (x='+this.m_offset.x + ', y='+this.m_offset.y +')');
		},
		resetScrollOffset:function(){
			this.m_offset = { 'x': 0, 'y': 0, };
			const data = JSON.stringify(this.m_offset);
			sessionStorage.setItem(this.m_key, data);
			console.log('reset scloll offset: (x='+this.m_offset.x + ', y='+this.m_offset.y +')');
		},
		saveScrollOffset:function(){
			const data = JSON.stringify(this.m_offset);
			sessionStorage.setItem(this.m_key, data);
			console.log('save scloll offset: ' + data);
		},
		restoreScrollOffset:function(){
			if (!this.m_bRestoreScroll) {
				this.m_bRestoreScroll = true;
				return;
			}
			var data = sessionStorage.getItem(this.m_key);
			if (data) {
                try {
					this.m_offset = JSON.parse(data);
					window.scrollTo(this.m_offset.x, this.m_offset.y);
					console.log('restore scloll offset: (x='+this.m_offset.x + ', y='+this.m_offset.y +')');
                } catch(e) {
					console.log(e);
				}
				sessionStorage.removeItem(this.m_key);
				this.m_offset = { 'x': 0, 'y': 0, };
			}
		},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/windowScroll.mixin.vue